import { useState, useRef, useCallback } from 'react';

export const useSearchInput = (backendUrl) => {
  const [inputValue, setInputValue] = useState('');
  const [cities, setCities] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const inputRef = useRef(null);
  const timeoutRef = useRef(null);

  const handleInputChange = useCallback((value) => {
    setInputValue(value);
    setShowDropdown(false);
    
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    
    if (value.length >= 2) {
      setIsLoading(true);
      timeoutRef.current = setTimeout(async () => {
        try {
          const searchLimit = value.toLowerCase().includes('budapest') ? 50 : 20;
          const response = await fetch(`${backendUrl}/api/cities?search=${encodeURIComponent(value)}&limit=${searchLimit}`);
          if (response.ok) {
            const data = await response.json();
            setCities(data || []);
            setShowDropdown(data && data.length > 0);
          }
        } catch (error) {
          console.error('Cities fetch error:', error);
        }
        setIsLoading(false);
      }, 300);
    } else {
      setCities([]);
    }
  }, [backendUrl]);

  const selectCity = useCallback((city) => {
    setInputValue(city.name);
    setShowDropdown(false);
    setCities([]);
    return city.name;
  }, []);

  const resetInput = useCallback(() => {
    setInputValue('');
    setCities([]);
    setShowDropdown(false);
  }, []);

  return {
    inputValue,
    municipalities: cities,
    showDropdown,
    isLoading,
    handleInputChange,
    selectMunicipality: selectCity,
    resetInput,
    inputRef
  };
};
